import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { budgetAPI, budgetTagsAPI } from 'src/app/services/apiRoutes';
import { BudgetUpdateModel } from '../models/budget-update';

@Injectable()
export class BudgetService {
  constructor(public http: HttpClient) {}

  bulkUpdateBudget(data: BudgetUpdateModel): Promise<BudgetUpdateModel> {
    return this.http.put<BudgetUpdateModel>(budgetAPI + '/' + data.identifier + '/bulk', data).toPromise();
  }

  getTags(query: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(budgetTagsAPI + '?query=' + query);
  }
}
